import React, {useState, useEffect, createContext} from 'react'
import { getToken, setToken, removeToken  } from '../api/token';
import { useUser } from '../hook/useUser';



export const AuthContext = createContext({
  auth: undefined,
  login: () => null,
  logout: () => null,

});


export function AuthProvider(props){
  
  const {children} = props;
  const [auth, setAuth] = useState(undefined);
  const {getMe} = useUser(); 

  //OBTENIENDO DATOS DEL INICIO DE SESION MEDIANTE UN USE-EFFECT

  useEffect(() => {    
    (async () =>{
     
      const token = getToken();
      
      if(token){
        const me = await getMe(token);
        setAuth({token, me});
      
      }else{
        //IMPORTANTE PARA QUE ABAJO FUNCIONE CORRECTAMENTE
        setAuth(null);
      }
      
    })();
    
  }, [])
  

  const login = async (token) => {
    setToken(token);
    const me = await getMe(token);
    setAuth({token, me});
    //console.log(me);     
  }

  const logout = () =>{
    if(auth){
      removeToken();
      setAuth(null);      
    }
    
  }

  const valueContext = {
    auth,
    login,
    logout
  }

  if(auth === undefined) return null;

  return(
    <AuthContext.Provider value={valueContext}>
      {children}
    </AuthContext.Provider>
  )
}
